module.exports = __webpack_public_path__ + "4962b569fe34f1d63a194fcb9866a942.jpg";